import { render, staticRenderFns } from "./portal-about.vue?vue&type=template&id=45c65925&scoped=true&"
import script from "./portal-about.vue?vue&type=script&lang=js&"
export * from "./portal-about.vue?vue&type=script&lang=js&"
import style0 from "./portal-about.vue?vue&type=style&index=0&id=45c65925&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c65925",
  null
  
)

export default component.exports